export enum ArchivedItemType {
  PERSONA = 'PERSONA',
  SESSION = 'SESSION'
}
